export const token_address = process.env.REACT_APP_TOKEN_CONTRACT_ADDRESS;
export const nft_address = process.env.REACT_APP_DEPOSIT_CONTRACT_ADDRESS;

export const tiers = [1, 2, 3, 4];
export const saleState = {
  INACTIVE: 0,
  PRESALE: 1,
  PUBLICSALE: 2,
};
